import * as React from 'react';
import { Input, TextArea, Button, Slider } from '@kaleyra/emmy';
import { useTranslation } from 'react-i18next';

import { TagFieldNameType, TagType } from '../../../../../interface';

import Styles from './index.module.scss';

export type MapStatePropsType = {
	tag: TagType;
};

export type DispatchPropsType = {
	onChange: (fields: { name: TagFieldNameType; value: string }) => void;
	onClose: () => void;
};

const TagForm: React.FC<MapStatePropsType & DispatchPropsType> = ({
	onChange,
	onClose,
	tag,
}) => {
	const { t } = useTranslation();

	const getFooter = (): React.ReactNode => {
		return (
			<div className={Styles.footerContainer}>
				<Button type="tertiary" onClick={onClose}>
					{t('mainCancel')}
				</Button>
				<Button type="primary" onClick={onClose}>
					{t('apply')}
				</Button>
			</div>
		);
	};

	const onLocalChange = (name: TagFieldNameType) => (value: React.ChangeEvent<any>) => {
		onChange({
			name,
			value: value.target.value
		})
	};

	return (
		<Slider
			footer={getFooter()}
			visibility={true}
			containerId={'root-modal'}
			onClose={onClose}
			title={t('addContact')}
		>
			<div className={Styles.container}>
				<Input
					value={tag?.name}
					placeholder={t('BLD00287')}
					label={t('BLD00969')}
					onChange={onLocalChange('name')}
				/>
				<TextArea
					// css
					onChange={onLocalChange('description')}
                    value={tag?.description}
					placeholder={t('BLD00290')}
					label={t('BLD00290')}
					rows={6}
				/>
			</div>
		</Slider>
	);
};

export default TagForm;
